// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLink_modal__img__0dPgB {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.PaymentLink_main_nav__kImQL {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 1rem;
  background-color: var(--color-white);
  box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);
}
.PaymentLink_main_nav__kImQL > :not(:last-child) {
  margin-right: 6rem;
}
.PaymentLink_main_nav_group__Ubzb4 {
  position: relative;
}
.PaymentLink_main_nav_more__57k\\+Q {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.PaymentLink_main_nav_more__57k\\+Q > :not(last-child) {
  margin-bottom: 1rem;
}
.PaymentLink_main_nav_item__0Nt1P {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.PaymentLink_main_nav_item__0Nt1P:hover, .PaymentLink_main_nav_item__0Nt1P:focus, .PaymentLink_main_nav_item__0Nt1P:focus-visible, .PaymentLink_main_nav_item__0Nt1P:focus-within {
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}
.PaymentLink_main_nav_item_active__L56NY {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}
.PaymentLink_main_nav_item_active__L56NY:hover, .PaymentLink_main_nav_item_active__L56NY:focus, .PaymentLink_main_nav_item_active__L56NY:focus-visible, .PaymentLink_main_nav_item_active__L56NY:focus-within {
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}
.PaymentLink_main__content__SqWj1 {
  margin-top: 5rem;
}
.PaymentLink_main__metrics__i8JBu {
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .PaymentLink_main__metrics__i8JBu {
    grid-template-columns: repeat(2, 50%);
  }
}
.PaymentLink_main__metrics_active__7tAGv {
  background-color: var(--color-green);
  color: var(--color-white);
}
.PaymentLink_main__metrics_suspended__ToVNo {
  background-color: var(--color-yellow);
}
.PaymentLink_main__metrics_terminated__B1zM9 {
  background-color: var(--color-error);
  color: var(--color-white);
}
.PaymentLink_main__center__-PsUF {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PaymentLink_createLinks__v0eLl {
  display: grid;
  gap: 2rem;
  grid-template-columns: 60% 40%;
}
@media only screen and (max-width: 50em) {
  .PaymentLink_createLinks__v0eLl {
    grid-template-columns: 100%;
  }
}
.PaymentLink_createLinks_1__THBZn {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.PaymentLink_createLinks_2__cU2VL {
  background-color: var(--color-dark-2);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLink_createLinks_2__cU2VL img {
  width: 7rem;
}
.PaymentLink_createLinks_mini__Wbqe3 {
  background-color: var(--color-white);
  padding: 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.PaymentLink_beside__TTT2F {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLink_beside__TTT2F {
    grid-template-columns: 100%;
  }
}

.PaymentLink_status__pending__xvXfj {
  color: var(--color-yellow-3);
}
.PaymentLink_status__paid__KQD1f {
  color: var(--color-green);
}
.PaymentLink_status__failed__Lmabe {
  color: var(--color-error);
}

.PaymentLink_active__EI3tT {
  font-weight: 700;
  color: var(--color-green);
}

.PaymentLink_deactivated__iIkzf {
  font-weight: 700;
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PaymentLink/PaymentLink.module.scss"],"names":[],"mappings":"AAGE;EACE,cAAA;EACA,mBAAA;AAFJ;;AAOE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,oCAAA;EACA,gDAAA;AALJ;AASI;EACE,kBAAA;AAPN;AAUI;EACE,kBAAA;AARN;AAWI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAXN;AAiBM;EAIE,gBAAA;EACA,kCAAA;EACA,oDAAA;AAlBR;AAqBM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kCAAA;EACA,oDAAA;AAnBR;AAyBQ;EAIE,gBAAA;EACA,kCAAA;EACA,oDAAA;AA1BV;AAgCE;EACE,gBAAA;AA9BJ;AAiCE;EACE,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AA/BJ;AAiCI;EATF;IAUI,qCAAA;EA9BJ;AACF;AAgCI;EACE,oCAAA;EACA,yBAAA;AA9BN;AAiCI;EACE,qCAAA;AA/BN;AAkCI;EACE,oCAAA;EACA,yBAAA;AAhCN;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAnCF;AAqCE;EALF;IAMI,2BAAA;EAlCF;AACF;AAoCE;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;AAlCJ;AAqCE;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAnCJ;AAqCI;EACE,WAAA;AAnCN;AAuCE;EACE,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,WAAA;AArCJ;;AAyCA;EACE,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAtCF;AAwCE;EANF;IAOI,2BAAA;EArCF;AACF;;AAyCE;EACE,4BAAA;AAtCJ;AAyCE;EACE,yBAAA;AAvCJ;AA0CE;EACE,yBAAA;AAxCJ;;AA4CA;EACE,gBAAA;EACA,yBAAA;AAzCF;;AA4CA;EACE,gBAAA;EACA,yBAAA;AAzCF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.modal {\n  &__img {\n    height: 7.5rem;\n    margin-bottom: 3rem;\n  }\n}\n\n.main {\n  &_nav {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 2rem;\n    padding: 1rem;\n    // border-top: solid 1px var(--color-fash-primary-3);\n    background-color: var(--color-white);\n    box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);\n    // border-bottom: solid 1px var(--color-dark);\n    // border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 6rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-white);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      // @media only screen and (max-width: $bp-600) {\n      // \twidth: 47%;\n      // }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n      }\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n\n        // @media only screen and (max-width: $bp-600) {\n        // \twidth: 47%;\n        // }\n\n        &:hover,\n        &:focus,\n        &:focus-visible,\n        &:focus-within {\n          font-weight: 700;\n          color: var(--color-fash-primary-3);\n          border-bottom: solid 2px var(--color-fash-primary-3);\n        }\n      }\n    }\n  }\n\n  &__content {\n    margin-top: 5rem;\n  }\n\n  &__metrics {\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n    width: 100%;\n    display: grid;\n    box-sizing: border-box;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 50%);\n    }\n\n    &_active {\n      background-color: var(--color-green);\n      color: var(--color-white);\n    }\n\n    &_suspended {\n      background-color: var(--color-yellow);\n    }\n\n    &_terminated {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n  }\n\n  &__center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.createLinks {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: 60% 40%;\n\n  @media only screen and (max-width: $bp-800) {\n    grid-template-columns: 100%;\n  }\n\n  &_1 {\n    background-color: var(--color-white);\n    padding: 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  }\n\n  &_2 {\n    background-color: var(--color-dark-2);\n    padding: 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img {\n      width: 7rem;\n    }\n  }\n\n  &_mini {\n    background-color: var(--color-white);\n    padding: 2rem;\n    margin: 1rem 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    width: 100%;\n  }\n}\n\n.beside {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 2rem;\n\n  @media only screen and (max-width: $bp-500) {\n    grid-template-columns: 100%;\n  }\n}\n\n.status {\n  &__pending {\n    color: var(--color-yellow-3);\n  }\n\n  &__paid {\n    color: var(--color-green);\n  }\n\n  &__failed {\n    color: var(--color-error);\n  }\n}\n\n.active {\n  font-weight: 700;\n  color: var(--color-green);\n}\n\n.deactivated {\n  font-weight: 700;\n  color: var(--color-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `PaymentLink_modal__img__0dPgB`,
	"main_nav": `PaymentLink_main_nav__kImQL`,
	"main_nav_group": `PaymentLink_main_nav_group__Ubzb4`,
	"main_nav_more": `PaymentLink_main_nav_more__57k+Q`,
	"main_nav_item": `PaymentLink_main_nav_item__0Nt1P`,
	"main_nav_item_active": `PaymentLink_main_nav_item_active__L56NY`,
	"main__content": `PaymentLink_main__content__SqWj1`,
	"main__metrics": `PaymentLink_main__metrics__i8JBu`,
	"main__metrics_active": `PaymentLink_main__metrics_active__7tAGv`,
	"main__metrics_suspended": `PaymentLink_main__metrics_suspended__ToVNo`,
	"main__metrics_terminated": `PaymentLink_main__metrics_terminated__B1zM9`,
	"main__center": `PaymentLink_main__center__-PsUF`,
	"createLinks": `PaymentLink_createLinks__v0eLl`,
	"createLinks_1": `PaymentLink_createLinks_1__THBZn`,
	"createLinks_2": `PaymentLink_createLinks_2__cU2VL`,
	"createLinks_mini": `PaymentLink_createLinks_mini__Wbqe3`,
	"beside": `PaymentLink_beside__TTT2F`,
	"status__pending": `PaymentLink_status__pending__xvXfj`,
	"status__paid": `PaymentLink_status__paid__KQD1f`,
	"status__failed": `PaymentLink_status__failed__Lmabe`,
	"active": `PaymentLink_active__EI3tT`,
	"deactivated": `PaymentLink_deactivated__iIkzf`
};
export default ___CSS_LOADER_EXPORT___;
